const content = [
  {
    img: '/programy_sponsorowane.png',
    header: 'Programy sponsorowane',
    text: 'Programy sponsorowane to cykl audycji telewizyjnych stworzonych przy udziale ekspertów Sponsora programu. Adresowane są do firm, które chciałyby wypromować swoje usługi, produkty przy pomocy cyklu audycji telewizyjnych o charakterze poradnika w danym temacie.',
  },
  {
    img: '/reportaze_sponsorowane.png',
    header: 'Reportaże sponsorowane',
    text: 'Reportaż sponsorowany to materiał przedstawiający firmę, usługę, produkt lub wydarzenie dotyczące firmy Sponsora. Reportaże sponsorowane są ofertą skierowaną do firm, które chciałyby wypromować swoje usługi, produkty przy pomocy materiału reportażowego z elementami lokowania produktu. Reportaż sponsorowany jest jedną z bardziej wyspecjalizowanych i nowoczesnych form promocji.',
  },
  {
    img: '/realizacje_studyjne_realizacje_zewnetrzne.png',
    header: 'Realizacje studyjne, realizacje zewnętrzne',
    text: 'Proponujemy zarówno realizacje na żywo nagrywane jak i realizacje nagrywane i emitowane w późniejszym terminie. W tej formie promocji nie ma określonego scenariusza, przedstawiamy wydarzenie kulturalne, rozrywkowe lub sportowe z wykorzystaniem studia w plenerze lub studia wirtualnego. Proponujemy również scenografię studia plenerowego lub projekt studia wirtualnego indywidualny dla klienta. Przy realizacjach klienci mogą proponować tytuł programu i wizję grafiki (oprawę graficzną oraz grafikę ekranową.). ',
  },
  {
    img: '/wejscia_na_zywo.png',
    header: 'Wejścia na żywo',
    text: 'Dysponujemy najnowocześniejszym sprzętem telewizyjnym umożliwiającym realizację i emisję materiału z każdego miejsca bez użycia wozu transmisyjnego. Relacja z wydarzenia w postaci kilku wejść na żywo to niestandardowa forma promocji.',
  },
  {
    img: '/film_promocyjny.png',
    header: 'Film promocyjny',
    text: 'Film promocyjny może być bardzo skuteczną formą promocji. Wystarczy oryginalny pomysł i dobre wykonanie. Zwracamy szczególną uwagę na proces przygotowania do produkcji: poznanie oczekiwań klienta, określenie grupy docelowej i stworzenie odpowiedniej, przemyślanej koncepcji. Zajmujemy się produkcją filmów: promocyjnych, wizerunkowych, rekrutacyjnych dla HR, szkoleniowych i instruktażowych oraz filmów z eventów i konferencji. ',
  },
  {
    img: '/spoty_reklamowe.png',
    header: 'Spoty reklamowe',
    text: 'Spot reklamowy jest jednym z najlepszych sposobów promocji ze względu na ogromny zasięg, możliwość pokazania i przekazania wielu informacji w krótkim czasie i zawarcia bezpośredniego komunikatu. Stosując się do sprawdzonych procedur tworzymy spoty, które dają efekty i potrafią wyróżnić się w bloku reklamowym.',
    docs: {
      file: 'docs/cennik_emisji_spotow_nowe_pasma.pdf',
      text: 'Pobierz cennik',
    },
  },
  {
    img: '/bilboard_sponsorski.png',
    header: 'Bilboard sponsorski',
    text: 'Oferujemy możliwość sponsorowania prognozy pogody, programów sportowych, kulturalnych i rozrywkowych. Billboard sponsorski emitowany jest przed i po danym programie telewizyjnym. Bezpośrednie sąsiedztwo z audycją i krótki czas emisji bloku sponsorskiego owocują większym zaangażowaniem widza.  ',
  },
  {
    img: '/reklama_w_internecie.png',
    header: 'Reklama w internecie',
    text: 'Reklama na stronie internetowej TV TOYA to ciekawa forma uzupełnienia i rozszerzenia kampanii telewizyjnej. Reklama internetowa jest dynamiczna i interaktywna. Internauta może od razu zareagować na ofertę i nawiązać kontakt z firmą.  ',
    docs: {
      file: 'docs/reklama_w_internecie.pdf',
      text: 'Reklama w internecie',
    },
  },
  {
    img: '/patronat_medialny.png',
    header: 'Patronat medialny',
    text: 'Patronat przyznawany jest imprezom i wydarzeniom o charakterze regionalnym lub ponadregionalnym, które nie stoją w sprzeczności z misją Telewizji TOYA i służą przede wszystkim promocji Łodzi i regionu. Wniosek o objęcie patronatem medialnym Telewizji TOYA należy złożyć w terminie minimum 14 dni przed imprezą. Przyznanie patronatu nie jest równoznaczne z otrzymaniem bezpłatnych kampanii reklamowych na antenie TV TOYA.',
    docs: {
      file: 'docs/wniosek_patronat_medialny.doc',
      text: 'Pobierz wniosek',
    },
  },
];

export default content;
